const eventCategories = {
    PURCHASE_WIDGET_SDK_TOS: "Terms of Sale",
    LINK_TRACKING: "Link tracking",
    PURCHASE_WIDGET_SDK_FORM_SUBMIT: "Purchase Widget SDK Sales Funnel",
    CARD_FIELD_ERROR: "Purchase Widget Card Field",
};

export default eventCategories;
